export const getSortedItems = (items: any[], sortOption = 'name') => {
  return [...items].sort((a, b) => {
    switch (sortOption) {
      case 'price':
        return a.price - b.price
      case 'releaseDate':
        return (
          new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()
        )
      case 'name':
      default:
        return a.name.localeCompare(b.name)
    }
  })
}
